"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var headcell_1 = require("../model/headcell");
var table_1 = require("../model/table");
var cell_1 = require("../model/cell");
var row_1 = require("../model/row");
var table_view_manager_1 = require("./table-view-manager");
var tree_view_manager_1 = require("./tree-view-manager");
var style_converter_1 = require("../../../sis-tabular-report-options/converter/style-converter");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var cell_style_merger_1 = require("../../../sis-tabular-report-options/merger/cell-style-merger");
var ReportTreeToTableParser = /** @class */ (function () {
    function ReportTreeToTableParser() {
    }
    ReportTreeToTableParser.parse = function (tree, options) {
        var rowsCount = options.rowsCount;
        // calculate tree depth
        var depth = tree_view_manager_1.TreeViewManager.calculateDepth(tree) - 1;
        // create table head
        var tableHead = this.createTableHead(tree, depth);
        // calculate columns count
        var columnsCount = tree_view_manager_1.TreeViewManager.getColSpan(tree);
        // get tree leaf nodes
        var leafNodes = tree_view_manager_1.TreeViewManager.getLeafNodes(tree);
        // create table body
        var body = this.createTableBody(rowsCount, columnsCount, leafNodes, options);
        return new table_1.Table(tableHead, body, columnsCount, rowsCount, depth, options);
    };
    ReportTreeToTableParser.createTableHead = function (tree, depth) {
        var tableHead = new Array(depth);
        for (var level = 0; level < depth; level++) {
            var nodes = tree_view_manager_1.TreeViewManager.getNodesByLevel(tree, level);
            tableHead[level] = new Array(nodes.length);
            for (var j = 0; j < nodes.length; j++) {
                var node = nodes[j];
                tableHead[level][j] = new headcell_1.HeadCell(node, tree_view_manager_1.TreeViewManager.getColSpan(node), tree_view_manager_1.TreeViewManager.getRowSpan(node, level, depth));
            }
        }
        return tableHead;
    };
    ReportTreeToTableParser.createTableBody = function (rowsCount, columnsCount, leafNodes, options) {
        var body = new Array(rowsCount);
        for (var i = 0; i < rowsCount; i++) {
            body[i] = this.createTableBodyRow(columnsCount, leafNodes, options.info.get(i));
        }
        // last 'new' row
        body[rowsCount] = this.createTableBodyRow(columnsCount, leafNodes);
        // fill table body rows attributes if specified
        if (options) {
            table_view_manager_1.TableViewManager.fillTableBodyOptions(body, options);
        }
        return body;
    };
    ReportTreeToTableParser.createTableBodyRow = function (columnsCount, leafNodes, rowCategoryStyleDto) {
        var row = new row_1.Row();
        row.cells = new Array(columnsCount);
        row.rowCategoryStyleDto = rowCategoryStyleDto;
        for (var j = 0; j < columnsCount; j++) {
            var cell = new cell_1.Cell();
            var cellStyle = this.resolveStyle(rowCategoryStyleDto, leafNodes[j]);
            cell.styles = style_converter_1.StyleConverter.covert(cellStyle);
            cell.node = leafNodes[j];
            row.cells[j] = cell;
        }
        return row;
    };
    ReportTreeToTableParser.resolveStyle = function (rowCategoryStyleDto, currentNode) {
        var arr = [];
        var measureStyle;
        while (currentNode) {
            if (currentNode.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                if (currentNode.columnStyleDto) {
                    measureStyle = currentNode.columnStyleDto.valueStyle;
                }
            }
            if (currentNode.element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                if (currentNode.columnStyleDto) {
                    if (currentNode.columnStyleDto.valueStyle) {
                        arr.push(currentNode.columnStyleDto.valueStyle);
                    }
                }
            }
            currentNode = currentNode.parent;
        }
        arr = arr.reverse();
        if (rowCategoryStyleDto) {
            if (rowCategoryStyleDto.valueStyle) {
                var rowStyle = Object.create(rowCategoryStyleDto.valueStyle);
                rowStyle.width = undefined;
                arr.splice(0, 0, rowStyle);
            }
        }
        if (measureStyle) {
            arr.push(measureStyle);
        }
        return cell_style_merger_1.CellStyleMerger.mergeTextStyles(arr);
    };
    return ReportTreeToTableParser;
}());
exports.ReportTreeToTableParser = ReportTreeToTableParser;
//# sourceMappingURL=report-tree-to-table-parser.js.map